import React, { useState, useEffect } from 'react';
import { getTransactionsByParams } from '../../actions/Companies/getTransactionsByParams';
import { ReduxState } from '../../reducers/types';
import { bindActionCreators, Dispatch } from 'redux';
import { connectWithRouter } from 'helpers/connectWithRouter';
import { TransactionQueryForm } from './TransactionQueryForm';
import { selectTransactionRow } from '../../actions/Companies/selectTransactionTableRow';
import { TransactionTable } from './TransactionTable';
import { enqueueSnackbarCustomMessageHandler } from '../../actions/Status';

import styles from './styles.pcss';
type Props = {
  orgId: string | undefined;
  getTransactionsByParams: Function;
  selectTransactionRow: Function;
  transactions?: any;
  enqueueSnackbarCustomMessageHandler: Function;
};

export function MissingTransactionsTool(props: Props) {
  return (
    <div className={styles.missingTransactionTool}>
      <TransactionQueryForm
        searchTransactions={props.getTransactionsByParams}
        orgId={props.orgId}
      />
      <TransactionTable
        transactions={props.transactions}
        selectTransactionRow={props.selectTransactionRow}
        enqueueSnackbarCustomMessageHandler={
          props.enqueueSnackbarCustomMessageHandler
        }
      />
    </div>
  );
}

function mapStateToProps(state: ReduxState) {
  return { transactions: state.transactions };
}

function mapDispatchToProps(dispatch: Dispatch) {
  return bindActionCreators(
    {
      getTransactionsByParams,
      selectTransactionRow,
      enqueueSnackbarCustomMessageHandler,
    },
    dispatch,
  );
}

export default connectWithRouter(
  mapStateToProps,
  mapDispatchToProps,
)(MissingTransactionsTool);
